import { apiSlice } from "./authApi";

const userApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // getUsers: builder.query({
        //     providesTags: (result, error, user) => {
        //         const tags = result.map((user) => {
        //             return { type: "User", id: user.id };
        //         });
        //         return tags;
        //     },
        //     query: () => {
        //         return {
        //             url: "/users/",
        //             method: "GET",
        //         };
        //     },
        // }),

        getUsers: builder.query({
            providesTags: (result, error) => {
                if (result?.results) {
                    return result.results.map(user => ({
                        type: "User",
                        id: user.id,
                    }));
                } 
                return [{ type: "User", id: "List" }];     
            },
            query: ({ page = 1, pageSize = 5 } = {}) => ({
                url: `/users/?page=${page}&pageSize=${pageSize}`,
                method: "GET",
            }),
        }),

        getUser: builder.query({
            query: (id) => ({ url: `/users/${id}/` }),
            providesTags: (result, error, id) => [{ type: "User", id }],
        }),

        deleteUser: builder.mutation({
            invalidatesTags: (result, error, id) => {
                return [{ type: "User", id }];
            },
            query: (id) => {
                return {
                    url: `/users/${id}/`,
                    method: "DELETE",
                };
            },
        }),

        createUser: builder.mutation({
            invalidatesTags: (result, error, user) => {
                return [
                    {
                        type: "User",
                        id: user.id,
                    },
                ];
            },
            query: (user) => {
                return {
                    url: "/users/",
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: user,
                };
            },
        }),

        updateUser: builder.mutation({
            query: (user) => ({
                url: "/users/" + user.id + "/",
                method: "PATCH",
                body: { ...user },
                headers: {
                    "Content-Type": "application/json",
                },
            }),
            invalidatesTags: (result, error, user) => {
                return [
                    {
                        type: "User",
                        id: user.id,
                    },
                ];
            },
        }),

        getCurrentUser: builder.query({
            query: () => ({ url: "/current-user/" }),
            providesTags: ["User"],
        }),

        updateCurrentUser: builder.mutation({
            query: (user) => ({
                url: '/current-user/',
                method: 'PATCH',
                body: user,
            }),
            invalidatesTags: ["User"],
        })
    }),
});

export const {
    useGetUsersQuery,
    useGetUserQuery,
    useCreateUserMutation,
    useDeleteUserMutation,
    useUpdateUserMutation,
    useGetCurrentUserQuery,
    useUpdateCurrentUserMutation
} = userApi;

export { userApi };
